import { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
// import { CategoriesContext } from '../../context/categories.context';
import { useParams } from 'react-router-dom';
import {
  selectCategoriesMap,
  selecCategoriesIsLoading,
} from '../../store/categories/category.selector';
import ProductCard from '../../components/product-card/product-card.component';
import Spinner from '../../components/spinner/spinner.component';
import { CategoryContainer, Title } from './category.styles';

type CategoryRouteParams = {
  category: string;
};

const Category = () => {
  const { category } = useParams<
    keyof CategoryRouteParams
  >() as CategoryRouteParams;
  // const { categoriesMap } = useContext(CategoriesContext);
  console.log('render/re-render category component');
  const categoriesMap = useSelector(selectCategoriesMap);
  const isLoading = useSelector(selecCategoriesIsLoading);
  const [products, setProducts] = useState(categoriesMap[category]);
  useEffect(() => {
    console.log('effect fired calling setProducts');

    setProducts(categoriesMap[category]);
  }, [category, categoriesMap]);
  return (
    <Fragment>
      <Title className='category-title'>{category.toUpperCase()}</Title>
      {isLoading ? (
        <Spinner />
      ) : (
        <CategoryContainer>
          {products &&
            products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
        </CategoryContainer>
      )}
    </Fragment>
  );
};
export default Category;
